import Footer from './Footer.styled';

export default Footer;
